import { createSelector, createSlice } from '@reduxjs/toolkit';
import { getPortalId } from '../utils/getPortalId';
export const initialState = {
  gates: [],
  hasWorkflowsAccess: false,
  hubAccountNameOrDomain: '',
  portalId: getPortalId() || 0,
  portalType: ''
};
export const portalSlice = createSlice({
  name: 'portal',
  initialState,
  reducers: {}
});
export const getPortal = state => state.portal;
export const getIsHubless = createSelector([getPortal], portal => portal.portalId === 0);
export const selectGates = createSelector([getPortal], portal => portal.gates);
export default portalSlice.reducer;